module.exports = __webpack_public_path__ + "img/markerMetroRed.fbc27cd6.svg";